import React from "react";
import "./footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import "./mainfooter.css";
import { color } from "framer-motion";
import logofooter from "../assets/images/logo.png"
import { useEffect, useState } from 'react';

const HeroFooter = () => {

  const [isButtonVisible, setIsButtonVisible] = useState(false);

  // Show or hide the scroll-up button based on scroll position
  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsButtonVisible(true);
    } else {
      setIsButtonVisible(false);
    }
  };

  // Smooth scroll to the top with custom duration
  const scrollToTop = () => {
    // Smooth scroll logic with a custom duration for even smoother scroll
    const scrollDuration = 2500; // Adjust the duration for smoother/slower scroll
    const start = window.scrollY;
    const end = 0;
    const change = start - end;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / scrollDuration, 1); // Ensure progress doesn't go beyond 1
      window.scrollTo(0, start - change * progress);
      if (progress < 1) {
        requestAnimationFrame(animateScroll); // Continue animating until fully scrolled
      }
    };

    requestAnimationFrame(animateScroll);
  };

  useEffect(() => {
    // Add scroll event listener when the component mounts
    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <>
      {/* Hero Section */}
      

       <footer className="induratna-footer">
            <div className="induratna-footer-container">
              <div className="induratna-footer-columns">
               
              <div className="induratna-footer-column">

                  <div className="" style={{display:"flex"}}>
                  <div className="footerlogo">
                    <img src={logofooter} className="footerlogo"/>
                  </div>              
                  <div className="foothead"><h3 style={{color:"white"}}>InduRatna Law <span style={{color:"white", margin: "20px"}}>Associates</span></h3> </div>
                  </div>



                </div>

           
                {/* Company Section */}
                <div className="induratna-footer-column footcompany" >
                  <h3>Important Links</h3>
                  <ul>
                    <li><a href="#">Home</a></li>
                    <li><a href="#">About Us</a></li>
                    <li><a href="#">Our Offerings</a></li>
                    <li><a href="#">Testimonials</a></li>
                    <li><a href="#">Contact Us</a></li>
                  </ul>
                </div>
      
                {/* Useful Links Section */}
                <div className="induratna-footer-column contactside ">
                  <h3>Useful Links</h3>
                  <ul>
                    <li><a href="#">- Foreign Collaborations</a></li>
                    <li><a href="#">- Joint Ventures </a></li>
                    <li><a href="#">- Corporate Law</a></li>
                    <li><a href="#">- Information Technology</a></li>
                    <li><a href="#">- Business Ventures</a></li>
                    <li><a href="#">- MSME</a></li>
                    <li><a href="#">- Mediation and Dispute Resolution</a></li>
                    <li><a href="#">- Start-up India Initiatives</a></li>
                    <li><a href="#">- Property and Real Estate</a></li>
                    
                  </ul>
                </div>
      


                {/* Contact Section */}
                <div className="induratna-footer-column contactside">
                  <h3>Contact Us</h3>
                  <p><FaMapMarkerAlt className="induratna-footer-icon locationicon"  /> Ratnaprabha, Dnyanesh Park, Lane 2, Krushna Chowk, Pimple Gurav, Pune - 411061</p>
                  <p><FaPhoneAlt className="induratna-footer-icon footcon" /> <span className="footcon1">+91 80079 13007</span></p>
                  <p><FaEnvelope className="induratna-footer-icon footcon" /><span className="footcon1"> sujata@induratnalaw.com</span></p>
                </div>
      
                {/* Newsletter Section */}
                {/* <div className="induratna-footer-column">
                  <h3>Subscribe to Our Newsletter</h3>
                  <p>Stay updated with our latest legal insights and updates.</p>
                  <div className="induratna-footer-subscribe">
                    <input type="email" placeholder="Your Email" />
                    <button>Subscribe</button>
                  </div>
                  <div className="induratna-footer-socials">
                    <a href="#"><FaFacebookF /></a>
                    <a href="#"><FaTwitter /></a>
                    <a href="#"><FaLinkedinIn /></a>
                    <a href="#"><FaInstagram /></a>
                  </div>
                </div> */}
      
              </div>
            </div>
      
            {/* Copyright Section */}
            <div className="induratna-footer-bottom">
              <p>© Copyright. InduRatna Law 2025. All Rights Reserved.   |  Designed by <a href="https://satkarsoftwares.com/" style={{color:"#c79c61"}}>Satkar Software Solutions Pvt Ltd</a>.</p>
            </div> 
            <button
          id="scrollUpBtn"
          className="scroll-up-btn"
          onClick={scrollToTop}
        >
          ↑
        </button>
          </footer>
     
    </>
  );
};

export default HeroFooter;
